import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeFixedCost, makeRangeCost, makeVariableCost } from '~/models/service-cost/makers.ts';
import { ServiceCostType } from './model';
import { price } from './pricing';
import * as selectors from './selectors';
export function setPriceIncrease(cost, priceIncrease) {
    return _object_spread_props(_object_spread({}, cost), {
        priceIncrease
    });
}
export function setPreapprovedAmount(cost, amount, controlledByAdvancedSettings) {
    if (cost.pricingType === ServiceCostType.Variable) {
        return _object_spread(_object_spread_props(_object_spread({}, cost), {
            unitCap: amount
        }), controlledByAdvancedSettings ? {
            preapprovedControlledByAdvancedSettings: true
        } : {
            preapprovedControlledByAdvancedSettings: false
        });
    }
    return cost;
}
export function setDiscount(cost, discount) {
    return _object_spread_props(_object_spread({}, cost), {
        discount
    });
}
export function setPrice(cost, newCost) {
    const withUnitPrice = (unitPriced)=>_object_spread_props(_object_spread({}, unitPriced), {
            price: price(newCost)
        });
    return selectors.match(cost, {
        fixed: withUnitPrice,
        variable: withUnitPrice,
        range: (range)=>_object_spread_props(_object_spread({}, range), {
                maxPrice: price(newCost),
                minPrice: selectors.minPrice(newCost)
            })
    });
}
export function setPrice2(cost, price) {
    const withUnitPrice = (unitPriced)=>_object_spread_props(_object_spread({}, unitPriced), {
            price
        });
    return selectors.match(cost, {
        fixed: withUnitPrice,
        variable: withUnitPrice,
        range: (range)=>_object_spread_props(_object_spread({}, range), {
                maxPrice: price,
                minPrice: range.minPrice
            })
    });
}
export function inputCostDataToModel(param) {
    let { pricing, price, minPrice, discount, priceIncrease, unitCap, unitName } = param;
    switch(pricing){
        case ServiceCostType.Fixed:
            return makeFixedCost(price, {
                discount,
                priceIncrease
            });
        case ServiceCostType.Range:
            return makeRangeCost(price, {
                minPrice: minPrice ? +minPrice : null,
                discount,
                priceIncrease
            });
        default:
            return makeVariableCost(price, {
                discount,
                unitName: pricing === 'unit' && unitName || null,
                unitCap: unitCap ? +unitCap : 0,
                priceIncrease
            });
    }
}
